import React from "react"
import ReactDOM from 'react-dom'


export default class TradingViewSymbolOverview extends React.Component 
  {
    state ={
      overviewVisible: false
    }
  
    generateCopyrightBlurb() {
      const tvURL = "https://www.tradingview.com/symbols/"+this.props.ticker
      let content = <><a href={tvURL} rel="noreferrer noopener" target="_blank">
                  <span className="blue-text" >{this.props.ticker} Price Today</span></a> by TradingView</>

     const copyright=document.createElement('div')
     copyright.className="tradingview-widget-copyright"
     copyright.id="tradingview-widget-copyright"
     //copyright.style={borderColor:"#cc0000",borderWidth:"1px",borderStyle:"solid"}
     ReactDOM.render(content,copyright)

        return copyright
      
    }
  render() { 
    
    return (
      <div id="tradingingsymboloverviewwidgetcontainer" style={{visibility:(this.state.overviewVisible)?'visible':'hidden'
      }}  className="tradingview-widget-container">
        <div className="tradingview-widget-container__widget"></div>
        <div className="tradingview-widget-copyright" id="tradingview-widget-copyright"></div>
      </div>
    )
  }
  removeWidgetScript() {
    const oldWidgetScript = document.getElementById("tradingingsymboloverviewscript")
    if (oldWidgetScript != null) oldWidgetScript.parentElement.removeChild(oldWidgetScript)

   

  }
  replaceCopyright() {
    const oldCopyright = document.getElementById("tradingview-widget-copyright")
    if (oldCopyright != null) oldCopyright.parentElement.removeChild(oldCopyright)
      document.getElementById("tradingingsymboloverviewwidgetcontainer").appendChild(this.generateCopyrightBlurb())
  }
  refreshWidget() {
    this.removeWidgetScript()
    if (this.props.ticker === "") { //hide component if we don't have a ticker
        this.setState({overviewVisible:false}) 
        return;
    } 
    const script = document.createElement('script')
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-info.js"
    script.async = true
    script.id="tradingingsymboloverviewscript"
    this.tvparams.symbol=this.props.ticker
    script.innerHTML = JSON.stringify(this.tvparams)

  
    document.getElementById("tradingingsymboloverviewwidgetcontainer").appendChild(script)
    script.onload = () => { 
      this.replaceCopyright() 
      }
    

    this.setState({overviewVisible:true}) 
  }
  componentDidUpdate(prevProps) {
    if (prevProps.ticker !== this.props.ticker) { //ticker has changed
      this.refreshWidget();
    }
  }
  componentDidMount(){
    this.refreshWidget()
  }

 tvparams = {
  "symbol": "NASDAQ:AAPL",
  "width": "100%",
  //"height":"100",
  "locale": "en",
  "colorTheme": "light",
  "isTransparent": true
}



  }



